export default function FlashDealPrice({
  price,
  comparePrice,
}) {
  const savings = Math.max(
    0,
    Number(comparePrice || 0) - Number(price || 0)
  );

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-end gap-3">
        <span className="text-2xl font-black text-foreground">
          ৳{Number(price || 0).toLocaleString()}
        </span>

        {comparePrice ? (
          <span className="pb-1 text-sm text-muted-foreground line-through">
            ৳{Number(comparePrice).toLocaleString()}
          </span>
        ) : null}
      </div>

      {savings > 0 ? (
        <p className="text-xs font-semibold text-emerald-600">
          You save ৳{savings.toLocaleString()}
        </p>
      ) : null}
    </div>
  );
}